(function () {
  'use strict';

  // Key written by the Hoppy Currency app embed; it switches currency in place, without a reload.
  var STORAGE_KEY = 'currentCurrency';
  var script = document.currentScript;
  var shopCurrency = script && script.dataset.shopCurrency;

  function selectedCurrency() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function sync() {
    var current = selectedCurrency();
    document.documentElement.classList.toggle('currency-foreign', !!current && current !== shopCurrency);
  }

  sync();
  window.addEventListener('storage', sync);
  document.addEventListener('click', function () { setTimeout(sync, 0); }, true);
  document.addEventListener('change', function () { setTimeout(sync, 0); }, true);
})();
